<template>
  <section class="py-3 px-8 border border-black rounded-2xl flex items-center justify-between bg-skin-primary shadow-request" v-if="typeActive==mentory.status">
    <section class="w-9/12 text-xs">
      <p class="font-bold " v-text="mentory.date.substring(0, 10)" />
      <p v-text="`${mentory.init_hour.substring(0, 5)} a ${mentory.end_hour.substring(0, 5)}`" />
      <div class="h-5 w-full truncate" 
      v-text="`${mentory.mentory_availables.module.name}`" />

      <section class="flex flex-col items-center" v-if="showBtn">
        <button
          @click="cancel(mentory.id)"
          class="rounded-lg text-xs mr-1 py-px px-2 bg-skin-pink text-white focus:outline-none"
          :class="{ 'opacity-50': loadingMentoryUser }"
          :disabled="loadingMentoryUser"
          v-text="'Eliminar'"
        />

        <button
          @click="showBtn = false"
          class="rounded-lg text-xs py-px px-2 bg-skin-gray text-white focus:outline-none"
          :class="{ 'opacity-50': loadingMentoryUser }"
          :disabled="loadingMentoryUser"
          v-text="'Cancelar'"
        />
      </section>
    </section>



    <section class="my-2 text-center w-3/12">
      <button class="text-skin-pink mb-2" @click="modalShow = true" v-if="mentory.status==1">
        Detalles
      </button>
      <button v-if="!showBtn && (mentory.status==0 || mentory.status==1)" @click="showBtn=true">
          <icon :name="'plus'" :width="30" :height="30" :color="'bg-skin-primary'" class="transform rotate-45 opacity-50" />
      </button>
    </section>
    <modal title="Instrucciones para la mentoria" :content="instructions" v-if="modalShow" @close="modalShow = false"/>
  </section>
</template>
<script>
import toastr from "toastr";
import { mapActions, mapGetters } from "vuex";
import { STORE_NAME_MENTORIES } from "../store/modules/mentories/";
import { STORE_NAME_COURSES } from "../store/modules/courses/";
export default {
    components:{
        Icon: () => import("../components/Icon.vue"),
        Modal: () => import("../components/Modal.vue"),
    },
    data: () => ({
        modalShow: false,
        showBtn: false,
        name:null,
        lastname:null,
        instructions:null,
        date:null,
        init:null,
        end:null,
        nameModule: null
    }),
    props:{
      mentory:{
        require: true,
      },
      typeActive:{
        require: true,
      }
    },
    computed:{
      ...mapGetters(STORE_NAME_MENTORIES, ["loadingMentoryUser"]),
    },
    methods:{
      ...mapActions(STORE_NAME_COURSES, ["changeDays"]),
      ...mapActions(STORE_NAME_MENTORIES, ["cancelMentoryUser"]), 
      async cancel(value){
        const resp = await this.cancelMentoryUser({_body: { mentoryUserId:value }})
        if(resp){
          this.changeDays({_days: resp.mentoryAvailables})
          toastr.success("Solicitud cancelada");
        } else 
          toastr.error("Surgio un problema!");

        this.showBtn = false
      }
    },
    mounted(){

      const array = this.mentory.fecha.split(' ')
      this.date = this.$date(array[0]).format("DD/MM/YYYY")

      const arrayInit = this.mentory.hora_inicio.split(':')
      const arrayEnd = this.mentory.hora_inicio.split(':')

      this.init = `${arrayInit[0]}:${arrayInit[1]}`
      this.end = `${arrayEnd[0]}:${arrayEnd[1]}`
      
      this.name = this.mentory.mentory_availables.mentory.mounted_course.course_owner.name
      this.lastname = this.mentory.mentory_availables.mentory.mounted_course.course_owner.lastname
      this.instructions = this.mentory.mentory_availables.mentory.instructions

      this.nameModule = this.mentory.mentory_availables.module.name
    }
};
</script>
